import styled from 'styled-components'
import { BoxDefault } from '../../../components/BoxContainer/styles'

export const BoxCertificate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ isButton }) =>
    isButton ? 'transparent' : 'var(--background)'};
  border: ${({ isButton }) =>
    isButton ? '0px' : '1px solid var(--border-color-table)'};
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px 50px;
  cursor: ${({ isButton, onClick }) =>
    isButton || onClick ? 'pointer' : 'normal'};

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h3 {
    margin-top: 14px;
    margin-bottom: 0;
    text-align: center;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
  }
`

export const BoxContainer = styled(BoxDefault)`
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`

export const BoxChooses = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 26px;
`

export const FileButton = styled.input`
  display: none;
`
